import actions from './actions';


const initState = {
    uploadLoader: false,
    uploadData: '',
    uploadError: '',
    getLoader: false,
    getData: '',
    getError: '',
}

export default function uploadReducer(state = initState, action) {
    switch (action.type) {
        case actions.UPLOAD_START: {
            return {
                ...state,
                uploadLoader: true
            }
        }
        case actions.UPLOAD_SUCCESS: {
            return {
                ...state,
                uploadLoader: false,
                uploadData: action?.data?.fileUri
            }
        }
        case actions.UPLOAD_ERROR: {
            return {
                ...state,
                uploadLoader: false,
                uploadError: action.message
            }
        }
        case actions.GET_FILE_START: {
            return {
                ...state,
                getLoader: true
            }
        }
        case actions.GET_FILE_SUCCESS: {
            return {
                ...state,
                getLoader: false,
                getData: action.data
            }
        }
        case actions.GET_FILE_ERROR: {
            return {
                ...state,
                getLoader: false,
                getError: action.message
            }
        }
        case actions.CLEAR_UPLOAD_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_UPLOAD_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}